import React, { Fragment } from 'react'
import Container from '../../../../constants/Container';
import { useFormik } from 'formik';
import SecHeading from '../../../../constants/SecHeading';
import { Grid } from '@mui/material';
import InputTextBox from '../../../../constants/InputTextBox';
import SelectInputBox from '../../../../constants/SelectInputBox';
import { CiCalendarDate } from 'react-icons/ci';
import { EndBaseLine } from '../../../../constants/AppSpace';
import { Button } from '../../../../constants/Button';
import { handleChangeDate, handleSelectBox } from '../../../../helpers/handleChange';
import { StockReportOptions } from '../../../../constants/Options';
import { fetchDataFromApi } from '../../../../helpers/api';
import AppURL from '../../../../constants/AppURL';
interface StockReportProps{
  setOnStockList:any;
}
const StockReportFormView:React.FC<StockReportProps> = ({setOnStockList}) => {
  const initialValues = {
    date_from :"",
    to_date:"",
    stock: "4",
  };
  const { values, errors, touched, setFieldValue, isSubmitting, handleBlur, handleChange, handleSubmit } = useFormik({
    initialValues,
    enableReinitialize: true,
    onSubmit: async (values, action) => {
      try {
        await fetchDataFromApi(AppURL.InventoryURL+"inventory/product/stocks/report/list/?stock="+values.stock).then((res)=>{
          setOnStockList(res?.results);
        });
      } catch (error) {
        console.error("Error saving product purchase:", error);
      }
    },
  });
  return (
    <Fragment>
      <Container padding={true}>
        <form onSubmit={handleSubmit}>
          <SecHeading type='add' label='Stock Report Search' />
          <Grid container columnSpacing={3} rowSpacing={0.8}>
            {/* <Grid item xl={6} lg={6} sm={6} md={6} xs={12}>
              <InputTextBox
                type='text'
                prefix={<CiCalendarDate />}
                name='date_from'
                label='From Date'
                handleChange={(e) => handleChangeDate(e, { setFieldValue, name: 'date_from' })}
                value={values.date_from}
                error={errors.date_from?.toString()}
                handleBlur={handleBlur}
                touched={touched.date_from ? Boolean(touched.date_from) : undefined}
                required={false}
                placeholder='XXXX/XX/XX'
              />
            </Grid>
            <Grid item xl={6} lg={6} sm={6} md={6} xs={12}>
              <InputTextBox
                type='text'
                prefix={<CiCalendarDate />}
                name='to_date'
                label='To Date'
                handleChange={(e) => handleChangeDate(e, { setFieldValue, name: 'to_date' })}
                value={values.to_date}
                error={errors.to_date?.toString()}
                handleBlur={handleBlur}
                touched={touched.to_date ? Boolean(touched.to_date) : undefined}
                required={false}
                placeholder='XXXX/XX/XX'
              />
            </Grid> */}
            <Grid item xl={12} lg={12} sm={12} md={12} xs={12}>
              <SelectInputBox
                label='Stock Report'
                options={StockReportOptions}
                name='stock'
                required={true}
                placeholder='Select Stock Report'
                optionSelect={(name, selectedOption) => {
                  handleSelectBox({ setFieldValue, name, value: selectedOption })
                }}
                handleBlur={() => {
                  handleBlur({ target: { name: 'stock' } });
                }}
                value={values.stock}
                touched={touched.stock}
                errors={errors.stock}
              />
            </Grid>

            <Grid item xl={12} lg={12} sm={12} md={12} xs={12}>
              <EndBaseLine top={30}>
                <Button btn_type='search' type='submit' el='button' />
              </EndBaseLine>
            </Grid>
          </Grid>
        </form>
      </Container>
    </Fragment>
  )
}

export default StockReportFormView